module.exports = __webpack_public_path__ + "static/img/icon-input-code.309c8dc6.png";